import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SabisNgxDialogService } from 'sabis-components2';
import { EmailTagsComponent } from './email-tags/email-tags.component';
import { EmailEditorInitDTO } from './models/api-models';

/** email composer/builder/authoring  */
@Injectable({
  providedIn: 'root'
})
export class EmailsService {

  constructor(@Inject('API_URL') private _apiUrl: string, private _http: HttpClient, private _dialogService: SabisNgxDialogService) { }

  public getEmailEditorData(filter: EmailFilterDTO): Observable<EmailEditorInitDTO> {
    let url: string = `${this._apiUrl}/emails/editor`;
    return this._http.post<EmailEditorInitDTO>(url, filter);
  }

  public openEmailTagsDialog(): Observable<boolean> {
    var dialog = this._dialogService.open(EmailTagsComponent, {
      maxHeight: '98vh', //set dialog max height to 98 viewport height (viewable screen's height')
    });

    return dialog.afterClosed().pipe(
      map(r => !!r)
    );
  }

  public isValidEmail(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    return emailRegex.test(email);
  }
}

export interface EmailFilterDTO {
  filterEmailTemplates: boolean;
  allowedEmailTemplateIds: number[];
  showRecipient: boolean;
  showEmailCC: boolean;
}
